import { FC, ReactNode, useState } from 'react'
import { EllipsisVerticalIcon } from 'components/icons'
import Button from './forms/Button'
import Dropdown from './forms/Dropdown'

type EllipsisDropdownType = {
  children?: ReactNode
  show?: boolean
  setShow?: (show: boolean) => void
  ellipsisIcon?: ReactNode
  disabled?: boolean
}

const dropdownIcon = <i className='fa fal fa-chevron-down' />
const buttonClass = 'hover-bg-light300'

const EllipsisDropdown: FC<EllipsisDropdownType> = ({
  children,
  disabled,
  ellipsisIcon = (
    <EllipsisVerticalIcon fill={disabled ? '#999999' : '#1D1D1F'} />
  ),
  setShow,
  show: controlledShow,
}: EllipsisDropdownType) => {
  // State to manage the show state internally if setShow is not provided
  const [internalShow, setInternalShow] = useState(false)

  // Determine if we are using controlled or internal state
  const isControlled = setShow !== undefined
  const show = isControlled ? controlledShow : internalShow

  const handleSetShow = (value: boolean) => {
    if (isControlled) {
      setShow?.(value)
    } else {
      setInternalShow(value)
    }
  }

  return (
    <>
      <Dropdown
        position='right'
        dropdownClassName='ms-4'
        show={show ?? false}
        setShow={handleSetShow}
        dropdownContent={children}
        icon={dropdownIcon}
      >
        <Button
          disabled={disabled}
          className={buttonClass}
          size='extra-small'
          onClick={(e) => {
            e?.stopPropagation()
            handleSetShow(!show)
          }}
          theme='text'
          icon
        >
          {ellipsisIcon}
        </Button>
      </Dropdown>
    </>
  )
}

export default EllipsisDropdown
